import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../media/TCOpfingen_Logo.png";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../App.js';

function ResetPassword() {
    const location = useLocation();
    const [newPassword, setNewPassword] = useState("");
    const [newPassword1, setNewPassword1] = useState("");
    const [isPasswordReset, setIsPasswordReset] = useState(true);
    const [isFocused, setIsFocused] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const userId = queryParams.get('playerId');
    const navigate = useNavigate();

    useEffect(() => {

        if (!token || !userId ) {
            toast.error("Ungültiger Link oder Token!");
            navigate("/login");
            return;
          }
        // Überprüfen, ob es sich um eine Passwort-Zurücksetzung oder eine erstmalige Passwort-Setzung handelt
        setIsPasswordReset(location.pathname !== '/set-password');
    }, [location.pathname, token, userId, navigate]);

    const handleFocus = () => {
        setIsFocused(true); // Formular verschieben
    };
    
    const handleBlur = () => {
        setIsFocused(false); // Zurück zur ursprünglichen Position
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (newPassword !== newPassword1) {
            toast.error("Die Passwörter stimmen nicht überein");
            return;
        }
        
        const formData = {
            token: token,
            playerId: userId,
            newPassword: newPassword
        };
        try {
            const endpoint = isPasswordReset ? "/api/password-reset-confirm" : "/api/set-password";
            await axios.post(`${API_BASE_URL}${endpoint}`, formData);
            toast.success(isPasswordReset ? "Passwort erfolgreich zurückgesetzt" : "Passwort erfolgreich gesetzt");
            navigate("/login");
        } catch (error) {
            toast.error(error.response?.data?.message || "Ein Fehler ist aufgetreten");
        }
    };

    return (
        <Box 
            sx={{
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                width: '100%',
                maxWidth: 450,
                position: 'fixed',
                top: isFocused ? '25%' : '50%',
                left: '50%',
                transform: isFocused ? 'translate(-50%, 0)' : 'translate(-50%, -50%)',
                transition: 'all 0.3s ease-in-out',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                overflow: 'hidden'
            }}
        >
            <div className='w-100 pt-3'>
                <img className="login-header-logo" src={logo} alt="logo" />
            </div>
            <div className='p-4'>
                <div className='text-center fw-semibold mb-3'>
                    {isPasswordReset ? "Passwort zurücksetzen" : "Neues Passwort setzen"}
                </div>
                <div>
                    <Form onSubmit={handleSubmit} className='text-center'>
                        <div className='d-flex justify-content-center align-items-center textfield'>
                            <div>
                                <Form.Group className="mb-4" controlId="formGroupNewPassword">
                                    <TextField
                                        id="newPassword"
                                        label="Neues Passwort"
                                        size="small"
                                        variant="outlined"
                                        type="password"
                                        className='bg-white-25 rounded'
                                        sx={{ width: '310px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: 'primary.main' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: 'primary.main' } } }}
                                        onChange={e => setNewPassword(e.target.value)}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="formGroupConfirmPassword">
                                    <TextField
                                        id="confirmPassword"
                                        label="Passwort bestätigen"
                                        variant="outlined"
                                        size="small"
                                        type="password"
                                        sx={{ width: '310px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: 'primary.main' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: 'primary.main' } } }}
                                        className='bg-white-25 rounded'
                                        onChange={e => setNewPassword1(e.target.value)}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className='text-center mt-3'>
                            <Button variant="contained" color="error" type="submit" sx={{ px: 4, py: 1 }}>
                                {isPasswordReset ? "Zurücksetzen" : "Erstellen"}
                            </Button>
                        </div>
                    </Form>
                    <div className='text-center'>
                        <p className='text-center mt-4 forgot-password mb-0' onClick={() => navigate("/login")}>Zum Login</p>
                    </div>
                </div>
            </div>
        </Box>
    );
}

export default ResetPassword;
